import React from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

export default function HtmlDisplay({ html }) {
  const sanitizedHtml = sanitizeHtml(html, { replaceJS: true });

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      className="min-h-[3.5vh] whitespace-normal"
    ></div>
  );
}
